/* global axios */
import ApiClient from './ApiClient';

class LingxingConfigAPI extends ApiClient {
  constructor() {
    super('lingxing_config', { accountScoped: true });
  }

  get() {
    return axios.get(this.url);
  }

  update(data) {
    return axios.patch(this.url, data);
  }

  verify() {
    return axios.post(`${this.url}/verify`, {});
  }

  syncExisting() {
    return axios.post(`${this.url}/sync_existing`, {});
  }
}

export default new LingxingConfigAPI();
